export function inviteBotStartUrl(
	botUsername: string,
	tgRefCode: string,
): string {
	const bot = botUsername.replace(/^@/, "").trim()
	return `https://t.me/${bot}?start=${tgRefCode}`
}
